// Command's current Supabase project (migrated from duexbbtvzyfhnkfiyrtr June 2026).
// Leads must post here so they appear in JobCam Command.
const SUPABASE_URL = "https://dmrofnpmqiffkqmedjkf.supabase.co";

export interface LeadPayload {
  company_name: string;
  contact_name?: string;
  email?: string;
  phone?: string;
  project_name?: string;
  project_address?: string;
  source?: string;
  single_vision_towers?: number;
  double_vision_towers?: number;
  service_security?: boolean;
  service_time_lapse?: boolean;
  service_project_management?: boolean;
  service_lpr?: boolean;
  service_ppe_detection?: boolean;
  estimated_start_date?: string;
  estimated_duration_months?: number;
  details?: string;
  files?: File[];
}

export async function submitLead(formData: LeadPayload) {
  const { files, ...fields } = formData;

  const body = new FormData();
  body.append("company_name", fields.company_name);
  body.append("contact_name", fields.contact_name || "");
  body.append("email", fields.email || "");
  body.append("phone", fields.phone || "");
  body.append("project_name", fields.project_name || "");
  body.append("project_address", fields.project_address || "");
  body.append("source", fields.source || "Website");
  body.append("estimated_duration_months", String(fields.estimated_duration_months || ""));
  body.append("estimated_start_date", fields.estimated_start_date || "");
  body.append("single_vision_towers", String(fields.single_vision_towers || 0));
  body.append("double_vision_towers", String(fields.double_vision_towers || 0));
  body.append("service_security", String(!!fields.service_security));
  body.append("service_project_management", String(!!fields.service_project_management));
  body.append("service_time_lapse", String(!!fields.service_time_lapse));
  body.append("service_lpr", String(!!fields.service_lpr));
  body.append("service_ppe_detection", String(!!fields.service_ppe_detection));
  body.append("details", fields.details || "");

  if (files) {
    for (const file of files) {
      body.append("files", file);
    }
  }

  const response = await fetch(
    `${SUPABASE_URL}/functions/v1/create-lead`,
    {
      method: "POST",
      body,
    }
  );

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error || "Failed to create lead");
  }

  return response.json();
}
